import { Routes } from '@angular/router';
import { NotFoundComponent } from './common/not-found/not-found.component';
import { SignInComponent } from './authentication/sign-in/sign-in.component';
import { AuthenticationComponent } from './authentication/authentication.component';
import { AddUserComponent } from './pages/users-page/add-user/add-user.component';
import { UsersListComponent } from './pages/users-page/users-list/users-list.component';
import { UsersPageComponent } from './pages/users-page/users-page.component';
import { authGuard } from './authentication/guards/auth.guard';
import { MapsPageComponent } from './pages/maps-page/maps-page.component';
import { ComingSoonPageComponent } from './pages/coming-soon-page/coming-soon-page.component';
import { DeveloperLogsComponent } from './pages/developer-logs/developer-logs.component';
import { UnauthorizedComponent } from './common/unauthorized/unauthorized.component';
import { UserDetailsComponent } from './pages/users-page/user-details/user-details.component';
import { UserGroupsComponent } from './pages/users-page/user-groups/user-groups.component';
import { AddUserGroupComponent } from './pages/users-page/add-user-group/add-user-group.component';
import { UpdateUserGroupComponent } from './pages/users-page/update-user-group/update-user-group.component';
import { AddPlantComponent } from './pages/plants/add-plant/add-plant.component';
import { LogDetailsComponent } from './pages/developer-logs/log-details/log-details.component';
import { guestGuard } from './authentication/guards/guest.guard';
import { AllPlantListComponent } from './pages/plants/all-plant-list/all-plant-list.component';
import { PlantListComponent } from './pages/plants/plant-list/plant-list.component';
import { PlantsDetailComponent } from './pages/plants/plants-detail/plants-detail.component';
import { CitiesListComponent } from './pages/city-list/city-list.component';
import { ActivityReportsComponent } from './pages/activity-reports/activity-reports.component';
import { AddInverterComponent } from './pages/plants/add-inverter/add-inverter.component';
import { UpdateInverterComponent } from './pages/plants/update-inverter/update-inverter.component';
import { UpdatePlantComponent } from './pages/plants/update-plant/update-plant.component';
import { InvoicesComponent } from './pages/invoices/invoices.component';
import { AllInvoicesListComponent } from './pages/invoices/all-invoices-list/all-invoices-list.component';
import { InvoiceDetailsComponent } from './pages/invoices/invoice-details/invoice-details.component';
import { OldVersionDasboardComponent } from './pages/old-version-dasboard/old-version-dasboard.component';
import { B2bDashboardPie } from './pages/pie-chart-dashboard/b2b-dashboard';

export const routes: Routes = [
    { path: '', redirectTo: 'presentation-dashboard', pathMatch: 'full' },
    {
        path: 'presentation-dashboard',
        loadComponent: () =>
            import('./pages/presentation-dashboard/presentation-dashboard.component')
                .then(m => m.PresentationDashboardComponent),
        canActivate: [authGuard],
    },
    { path: 'pie-dashboard', component: B2bDashboardPie, canActivate: [authGuard] },
    { path: 'old-dashboard', component: OldVersionDasboardComponent, canActivate: [authGuard] },
    {
        path: 'dashboard',
        loadComponent: () =>
            import('./pages/dashbord/dashbord.component').then(m => m.DashbordComponent),
        canActivate: [authGuard],
    },

    {
        path: 'b2bdashboard',
        loadComponent: () =>
            import('./pages/b2b-dashboard/b2b-dashboard').then(m => m.B2bDashboard),
        canActivate: [authGuard],
    },

    {
        path: 'plants',
        component: UsersPageComponent,
        canActivate: [authGuard],
        children: [
            {
                path: 'list',
                component: PlantListComponent,
                canActivate: [authGuard],
                data: { requiredRoles: ['CustomerAssets.Plants.View'] }
            },
            {
                path: 'map-view',
                component: MapsPageComponent,
                canActivate: [authGuard],
                data: { requiredRoles: ['CustomerAssets.Plants.View'] }
            },
            {
                path: 'alerts',
                component: ComingSoonPageComponent,
                canActivate: [authGuard],
                data: { requiredRoles: ['CustomerAssets.Plants.View'] }
            },
            {
                path: 'add-plant/:userId',
                component: AddPlantComponent,
                canActivate: [authGuard],
                data: { requiredRoles: ['CustomerAssets.Plants.Add'] }
            },
            {
                path: 'all-plant-list',
                component: AllPlantListComponent,
                canActivate: [authGuard],
                data: { requiredRoles: ['CustomerAssets.Plants.View'] }
            },
            {
                path: 'plants',
                loadComponent: () =>
                    import('./pages/plants/plant-list/plant-list-details-page/plant-list-details-page.component')
                        .then(m => m.PlantListDetailPageComponent),
                canActivate: [authGuard],
                data: { requiredRoles: ['CustomerAssets.Plants.View'] }
            },
            {
                path: 'search',
                loadComponent: () =>
                    import('./pages/plants/plant-list/plants-search-page/plants-search-page.component')
                        .then(m => m.PlantsSearchPageComponent),
                canActivate: [authGuard],
                data: { requiredRoles: ['CustomerAssets.Plants.View'] },
            },
            {
                path: 'detail',
                loadComponent: () =>
                    import('./pages/plants/plant-list/plant-list-details-page/plant-list-details-page.component')
                        .then(m => m.PlantListDetailPageComponent),
                canActivate: [authGuard],
                data: { anim: 'detail', requiredRoles: ['CustomerAssets.Plants.View'] }
            },
            {
                path: 'plants-detail/:id',
                component: PlantsDetailComponent,
                canActivate: [authGuard],
                data: { requiredRoles: ['CustomerAssets.Plants.View'] }
            },
            {
                path: 'update/:id',
                component: UpdatePlantComponent,
                canActivate: [authGuard],
                data: { requiredRoles: ['CustomerAssets.Plants.Edit'] }
            },
            {
                path: 'plants/:plantId/inverters/update',
                component: UpdateInverterComponent,
                canActivate: [authGuard],
                data: { requiredRoles: ['CustomerAssets.Plants.Edit'] }
            },
            {
                path: 'activity-reports',
                component: ActivityReportsComponent,
                canActivate: [authGuard],
                data: { requiredRoles: ['SmartCharge.Reports.AdminView'] }
            },
            {
                path: ':plantId/inverters/add',
                canActivate: [authGuard],
                data: { requiredRoles: ['CustomerAssets.Plants.Edit'] },
                component: AddInverterComponent
            },
            { path: '', pathMatch: 'full', redirectTo: 'plants/search' }
        ]
    },
    {
        path: 'users',
        component: UsersPageComponent,
        children: [
            { path: '', redirectTo: 'users-list', pathMatch: 'full' },
            {
                path: 'users-list',
                component: UsersListComponent,
                canActivate: [authGuard],
                data: { requiredRoles: ['Identity.User.View'] }
            },
            {
                path: 'add-user',
                component: AddUserComponent,
                canActivate: [authGuard],
                data: { requiredRoles: ['Identity.User.Create'] }
            },
            {
                path: 'user-details/:id',
                component: UserDetailsComponent,
                canActivate: [authGuard],
                data: { requiredRoles: ['Identity.User.View'] }
            },
            {
                path: 'user-groups',
                component: UserGroupsComponent,
                canActivate: [authGuard],
                data: { requiredRoles: ['Identity.User.View'] }
            },
            {
                path: 'add-user-group',
                component: AddUserGroupComponent,
                canActivate: [authGuard],
            },
            {
                path: 'edit-user-group/:id',
                component: UpdateUserGroupComponent,
                canActivate: [authGuard],
            },
        ]
    },

    {
        path: 'invoices',
        component: InvoicesComponent,
        canActivate: [authGuard],
        children: [
            { path: '', redirectTo: 'all-invoices-list', pathMatch: 'full' },
            {
                path: 'all-invoices-list',
                component: AllInvoicesListComponent,
                canActivate: [authGuard],
            },
            {
                path: 'invoice-details/:id',
                component: InvoiceDetailsComponent,
                canActivate: [authGuard],
            }
        ]
    },

    {
        path: 'messages',
        canActivate: [authGuard],
        component: UsersPageComponent,
        children: [{ path: 'tickets', component: ComingSoonPageComponent }]
    },

    {
        path: 'others',
        canActivate: [authGuard],
        component: UsersPageComponent,
        children: [
            { path: 'notifications', component: ComingSoonPageComponent },
            { path: 'developer-logs', component: DeveloperLogsComponent },
            { path: 'developer-logs/:id', component: LogDetailsComponent }
        ]
    },

    {
        path: 'city-list',
        canActivate: [authGuard],
        component: CitiesListComponent,
        data: { requiredRoles: ['CustomerAssets.Settings.Add'] }
    },

    {
        path: 'authentication',
        canActivate: [guestGuard],
        component: AuthenticationComponent,
        children: [{ path: '', component: SignInComponent }]
    },

    { path: 'unauthorized', component: UnauthorizedComponent },
    { path: '**', component: NotFoundComponent }
];